<template>
  <div>
    <v-dialog
      v-model="announcementDialog"
      scrollable
      persistent
      max-width="800"
    >
      <v-card flat>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1" flat dark height="50px">
            <span v-if="isEdit">{{ $t("home.tipUpdateAnnouncement") }}</span>
            <span v-else>{{ $t("home.addAnnouncement") }}</span>
            <v-spacer></v-spacer>
            <CloseIcon @click="onClose(false)" />
          </v-toolbar>
        </v-banner>
        <v-card-text style="height: 450px">
          <v-form ref="refAnnouncementForm" v-model="valid" lazy-validation v-on:submit.prevent>
            <v-row>
              <v-col cols="12" sm="12" class="pt-2 pb-0">
                <a-text-field
                  class="textField"
                  v-model="announcementForm.title"
                  dense
                  :label="$t('title')"
                  :requiredMessage="$t('ruleTitleReq')"
                  required
                  filled
                  color="neutralGray"
                ></a-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                {{ $t("poll.lblDescription") }}:
                <div
                  id="resize"
                  style="border: solid 1px lightgray; padding-bottom: 1px"
                >
                  <a-rich-text-editor
                    v-model="announcementForm.content"
                    @descriptionChange="descriptionChanges"
                  ></a-rich-text-editor>
                </div>
              </v-col>
              <v-col cols="12" sm="12" >
                <upload-file
                  :files="uploadingFiles"
                  :icons="fileIcons"
                  :rules="rules"
                  :clearList="announcementDialog"
                  v-on:add-files="addUploadingFiles"
                  v-on:remove-file="removeUploadingFile"
                  :accept="allowed_file"
                  v-on:file-error="fileError"
                ></upload-file>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <span
            v-if="errorCount > 0"
            class="error--text"
            style="
              font-family: 'Noto Sans JP';
              font-style: normal;
              font-weight: 400;
              font-size: 16px;
              line-height: 18px;
            "
            ><small>{{
              $t("documents.invalidFileMsg", { count: errorCount })
            }}</small></span
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                color="primaryDark"
                @click.stop="saveAnnouncementDetails"
                :disabled="errorCount > 0 || isDescriptionWithImage || (!isDirty || !announcementForm.title.length)"
              >
                {{ $t("btnSave") }}
              </a-btn>
            </template>
            <span>{{ $t("btnSave") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                color="secondary"
                class="ml-2"
                @click="onClose(false)"
                >{{ $t("btnClose") }}</a-btn
              >
            </template>
            <span>{{ $t("btnClose") }}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <prevent-confirmation
      :prevent="isDataUnSaved"
      @save="saveAnnouncementDetails"
      @discard="preventClose(true)"
      @cancel="preventClose(false)"
    >
    </prevent-confirmation>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { cloneDeep } from "lodash";
import UploadFile from "@/components/documents/UploadFile.vue";
import {
  allowed_file,
  fileIcons,
  MAX_UPLOAD_SIZE,
} from "../../utils/constant";
import { currentDateTime, createUUID, formatBytes } from "../../utils/util";
import PreventConfirmation from "../PreventConfirmation.vue";
export default {
  name: "AddAnnouncement",
  components:{
    UploadFile,
    PreventConfirmation
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    announcementForm: {
      type: Object,
      default: () => {},
    },
    isEdit: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isDataUnSaved: false,
      isDescriptionWithImage: null,
      showTextEditor: false,
      valid: true,
      uploadingFilesOld: this.announcementForm
        ? cloneDeep(this.announcementForm.documents)
        : [],
      initialData: null,
      uploadingFiles: [],
      deleteDocumentIds: [],
      maxsize: MAX_UPLOAD_SIZE,
      fileIcons,
      allowed_file,
      rules: [
        (v) =>
          !v ||
          !v.some((file) => file.size > 2000000) ||
          "File size should be less than 2 MB!",
      ],
      
    };
  },
  computed: {
    isDirty() {
      const UpdatedAnnouncementForm = {
        title: this.announcementForm.title,
        content: this.announcementForm.content,
        doc: this.uploadingFiles
      }
      return (
        (this.initialData !==
        JSON.stringify(UpdatedAnnouncementForm)) 
      ) 
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    announcementDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    errorCount() {
      let count = 0;
      for (const item of this.uploadingFiles) {
        if (this.checkStatus(item).status === false) {
          count++;
        }
      }
      return count;
    }
  },
  mounted() {
    let initialAnnouncement = {
      title: this.announcementForm.title,
      content: this.announcementForm.content,
      doc: this.announcementForm.documents
    }
    this.initialData = JSON.stringify(initialAnnouncement)
    this.uploadingFiles = this.announcementForm.documents.filter(i => i.isUploaded);
    setTimeout(() => {
      this.showTextEditor = true;
    }, 10);
  },
  methods: {
    ...mapActions({
      createAnnouncement: "news/createAnnouncement",
      updateAnnouncement: "news/updateAnnouncement",
      deleteDocuments: "document/deleteDocuments",
      createDocuments: "document/createDocuments",
    }),
    openAnnouncementDialog,
    onClose,
    preventClose,
    saveAnnouncementDetails,
    updateAnnouncementDetails,
    addAnnouncementDetails,
    descriptionChanges(val) {
      this.isDescriptionWithImage = val;
    },
    fileError(err) {
      this.showMessageSheet(
        err.error + " File(s) Size Limit Exceeded",
        "error"
      );
    },
    addUploadingFiles,
    removeUploadingFile,
    getFormData,
    scrollToBottomOfFileList() {
      let attempts = 0;
      const maxAttempts = 10;
      
      const attemptScroll = () => {
        attempts++;
        
        // First try to scroll the last item into view
        const lastItems = document.querySelectorAll('.file-list .v-list-item:last-child');
        if (lastItems.length > 0) {
          const lastItem = lastItems[lastItems.length - 1];
          lastItem.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'end',
            inline: 'nearest' 
          });
          
          // Additional scroll to ensure we're at the very bottom
          setTimeout(() => {
            const fileList = document.querySelector('.file-list');
            if (fileList) {
              fileList.scrollTop = fileList.scrollHeight + 100; // Add extra pixels
            }
          }, 300);
          return;
        }
        
        // Fallback: scroll all file-list containers to bottom
        const fileLists = document.querySelectorAll('.file-list');
        if (fileLists.length > 0) {
          fileLists.forEach(fileList => {
            fileList.scrollTop = fileList.scrollHeight + 100; // Add extra pixels to ensure bottom
            if (fileList.scrollTo) {
              fileList.scrollTo({
                top: fileList.scrollHeight + 100,
                behavior: 'smooth'
              });
            }
          });
          return;
        }
        
        // Retry if no elements found
        if (attempts < maxAttempts) {
          setTimeout(attemptScroll, 150);
        }
      };
      
      // Start attempting after a small delay
      setTimeout(attemptScroll, 100);
    },
    async documentsActions(announcementId) {
      if (this.deleteDocumentIds.length) {
        const promises = this.deleteDocumentIds.map((id) =>
          this.deleteDocuments(id)
        );
        await Promise.all(promises);
        this.deleteDocumentIds = [];
      }
      for (const item of this.uploadingFiles) {
        if (item.documentId && item.documentId != "") {
          continue;
        }
        if(!('isUploaded' in item) || item.isUploaded === false) {
          const documentId = createUUID();
          const formData = this.getFormData(item, documentId, announcementId);
          const newDocObj = {
            documentId: documentId,
            tenantid: this.selectedTenant,
            topicId: "",
            agendaid: "",
            directoryid: "",
            peopleid: "",
            announcementId: announcementId,
            name: item.name,
            type: item.type,
            size: item.size,
            lastModified: currentDateTime(item.lastModified),
            document_type: 'announcement_document'
          };
          await this.createDocuments(formData).then(() => {
            this.announcementForm.documents.push(newDocObj);
          });
        }
      }
    },
    checkStatus(file) {
      const maxSize = this.maxsize ?? 0;
      let filesWithStatus = {};
      if (!this.allowed_file.includes(file.type)) {
        filesWithStatus = {
          filename: file.name,
          status: false,
          message: this.$t("fileErrorMsg", { filename: file.fileName }),
        };
      } else if (file.size > maxSize) {
        filesWithStatus = {
          filename: file.name,
          status: false,
          message: this.$t("fileSizeErrorMsg", {
            maxsize: formatBytes(maxSize),
          }),
        };
      } else {
        filesWithStatus = {
          filename: file.name,
          status: true,
          message: "Success",
        };
      }
      return filesWithStatus;
    },
  },
};

function preventClose(status) {
  this.isDataUnSaved = false;
  if (status) {
    this.announcementDialog = false;
  } 
}
function addUploadingFiles(files) {
  files = Array.from(files);
  this.uploadingFiles.push(...files);
  
  // Scroll to bottom of file list when files are added (referenced from SendTemplateNotification)
  if (files.length > 0) {
    this.$nextTick(() => {
      this.scrollToBottomOfFileList();
    });
  }
}
function removeUploadingFile(index) {
  const deletedFile = this.uploadingFiles[index];
  if (deletedFile.documentId && deletedFile.documentId != "") {
    this.deleteDocumentIds.push(deletedFile.documentId);
    const docIndex = this.announcementForm.documents.findIndex(
      (doc) => doc.documentId === deletedFile.documentId
    );
    this.announcementForm.documents.splice(docIndex, 1);
  }
  this.uploadingFiles.splice(index, 1);
}
async function saveAnnouncementDetails() {
  try {
    if (this.$refs.refAnnouncementForm.validate()) {
      let announcementId = createUUID();
      if (this.announcementForm.id && this.announcementForm.id !== null) {
        announcementId = this.announcementForm.id;
      }
      await this.documentsActions(announcementId);
      this.announcementForm.documents = this.announcementForm.documents.map(({ isUploaded, ...rest }) => rest);
      if (this.announcementForm.id) {
        await this.updateAnnouncementDetails();
        this.$emit(
          "alert",
          this.$t("home.announcementUpdateSuccess"),
          "success"
        );
      } else {
        this.announcementForm.id = announcementId
        await this.addAnnouncementDetails();
        this.$emit(
          "alert",
          this.$t("home.announcementCreateSuccess"),
          "success"
        );
      }
      this.onClose(true);
    }
  } catch (error) {
    console.log(error, "api error")
  }
}

  function getFormData(item, documentId, announcementId) {
      let formData = new FormData();
      formData.append("tenantId", this.tenantId);
      formData.append("topicId", "");
      formData.append("documentId", documentId);
      formData.append("announcementId", announcementId);
      formData.append("meetingId", "");
      formData.append("agendaId", "");
      formData.append("directoryId", "");
      formData.append("peopleId", "");
      formData.append("file", item);
      formData.append("chunk_upload", false);
      formData.append("filename", item.name);
      formData.append("content_type", item.type);
      formData.append("document_type", "announcement_document");
      return formData;
    }

async function addAnnouncementDetails() {
  this.announcementForm.tenantid = this.tenantId;
  this.announcementForm.created_date = new Date().toISOString();
  await this.createAnnouncement(this.announcementForm);
}

async function updateAnnouncementDetails() {
  this.announcementForm.created_date = new Date().toISOString();
  await this.updateAnnouncement(this.announcementForm);
}

function openAnnouncementDialog() {
  this.announcementForm = cloneDeep(this.copyAnnouncementForm);
  this.announcementDialog = true;
  setTimeout(() => {
    this.showTextEditor = true;
  }, 10);
}

function onClose(fromSave) {
  if(this.$refs.refAnnouncementForm.validate() && !this.errorCount && this.isDirty && !fromSave && !this.isDescriptionWithImage) {
    this.isDataUnSaved = true
  } else {
    this.isDataUnSaved = false
    this.$refs.refAnnouncementForm.resetValidation();
    this.$refs.refAnnouncementForm.reset();
    this.announcementDialog = false;
    this.$emit("input", false);
  }
}
</script>

<style>
</style>